import state from './state'
import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import $axios from '../../axios';



export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/modules/licenses/index.js